import { motion } from 'framer-motion'
import { KeyRound, Lock } from 'lucide-react'
import { useStorytelling } from '@/context/StorytellingContext'
import { chapterMap } from '@/data/chapters'

export function SecretsPage() {
  const { secrets } = useStorytelling()
  const unlockedIds = new Set(secrets.map((s) => s.secretId))

  return (
    <div className="max-w-lg mx-auto px-5 py-6">
      <div className="px-5 py-4 -mx-5 -mt-6 mb-6" style={{ background: 'linear-gradient(135deg, var(--color-story-primary), var(--color-story-primary-light))' }}>
        <h1 className="font-display text-xl font-bold text-white">My Story Secrets</h1>
        <p className="text-sm text-white/80 mt-1">Tools you've discovered for making stories work</p>
      </div>

      <div className="flex flex-col gap-3">
        {chapterMap.map((chapter, index) => {
          const isUnlocked = unlockedIds.has(chapter.id)
          const secret = secrets.find((s) => s.secretId === chapter.id)

          if (isUnlocked && secret) {
            return (
              <motion.div key={chapter.id} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.05 }} className="flex gap-3 items-start bg-white rounded-xl p-4" style={{ border: '1px solid var(--color-story-border)' }}>
                <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: 'linear-gradient(135deg, var(--color-story-accent), #D49A2E)' }}>
                  <KeyRound className="w-4 h-4 text-amber-900" />
                </div>
                <div>
                  <p className="font-semibold text-sm" style={{ color: 'var(--color-story-text)' }}>{chapter.title}</p>
                  <p className="text-xs mt-1 leading-relaxed" style={{ color: 'var(--color-story-text-muted)' }}>{secret.principle}</p>
                </div>
              </motion.div>
            )
          }

          return (
            <div key={chapter.id} className="flex gap-3 items-center rounded-xl p-4 opacity-40" style={{ background: 'var(--color-story-bg-light)', border: '1px solid var(--color-story-border)' }}>
              <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: 'var(--color-story-locked)' }}>
                <Lock className="w-4 h-4 text-white" />
              </div>
              <div>
                <p className="font-semibold text-sm" style={{ color: 'var(--color-story-text)' }}>???</p>
                <p className="text-xs" style={{ color: 'var(--color-story-text-muted)' }}>Complete Chapter {index + 1} to unlock</p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
